import { render, staticRenderFns } from "./Wizardot4takephotos.vue?vue&type=template&id=682786dc&scoped=true&"
import script from "./Wizardot4takephotos.vue?vue&type=script&lang=js&"
export * from "./Wizardot4takephotos.vue?vue&type=script&lang=js&"
import style0 from "./Wizardot4takephotos.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Wizardot4takephotos.vue?vue&type=style&index=1&id=682786dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682786dc",
  null
  
)

export default component.exports